// insurer logos
import abhiLogo from '@/assets/insurerLogos/aditya-birla.png';
import avivaLogo from '@/assets/insurerLogos/aviva.png';
import bagicLogo from '@/assets/insurerLogos/bajaj-allianz.png';
import digitLogo from '@/assets/insurerLogos/digit.png';
import edelweissLogo from '@/assets/insurerLogos/edelweiss.png';
import hdfcLogo from '@/assets/insurerLogos/hdfc-ergo.png';
import iffcoLogo from '@/assets/insurerLogos/iffco-tokio.png';
import ilLogo from '@/assets/insurerLogos/icici-lombard.png';
import ipruLogo from '@/assets/insurerLogos/icici-prudential.png';
import magmaLogo from '@/assets/insurerLogos/magma-hdi.png';
import maxLifeLogo from '@/assets/insurerLogos/max-life.png';
import maxbupaLogo from '@/assets/insurerLogos/niva-bupa.png';
import newIndiaLogo from '@/assets/insurerLogos/new-india-insurance.png';
import orientalLogo from '@/assets/insurerLogos/oriental-insurance.png';
import plumLogo from '@/assets/insurerLogos/plum.png';
import pnbLogo from '@/assets/insurerLogos/pnb-metlife.png';
import relianceLogo from '@/assets/insurerLogos/reliance-general-insurance.png';
import religareLogo from '@/assets/insurerLogos/religare.png';
import sbiLogo from '@/assets/insurerLogos/sbi-general.png';
import starLogo from '@/assets/insurerLogos/star.png';
import tataAIALogo from '@/assets/insurerLogos/tata-aia.png';
import tataAIGLogo from '@/assets/insurerLogos/tata-aig.png';

// care type icons
import dayCareIcon from '@/assets/careTypeIcons/dayCare.svg';
import doctorConsulatationsIcon from '@/assets/careTypeIcons/doctorConsulations.svg';
import homeTreatmentIcon from '@/assets/careTypeIcons/homeTreatment.svg';
import hospitalisationIcon from '@/assets/careTypeIcons/hospitalisation.svg';
import prePostHospitalisationIcon from '@/assets/careTypeIcons/prePostHospitalisation.svg';
import AppConfig, { IS_DEVELOPMENT_ENV, IS_PROD_ENV } from '@/AppConfig';
import { EAddMemberRelationship, TGender } from '@/types';

//avatar
import KidAvatar from '@/assets/avatar/kid-avatar.png';
import WifeAvatar from '@/assets/avatar/female-spouse-avatar.png';
import HusbandAvatar from '@/assets/avatar/male-spouse-avatar.png';

export const INSURER_LOGOS = new Map<string, string>([
  ['abhi', abhiLogo],
  ['absl', abhiLogo],
  ['aviva', avivaLogo],
  ['bagic', bagicLogo],
  ['digit', digitLogo],
  ['edelweiss', edelweissLogo],
  ['hdfc', hdfcLogo],
  ['iffco', iffcoLogo],
  ['il', ilLogo],
  ['ipru', ipruLogo],
  ['magma', magmaLogo],
  ['maxLife', maxLifeLogo],
  ['maxbupa', maxbupaLogo],
  ['newIndia', newIndiaLogo],
  ['oriental', orientalLogo],
  ['plum', plumLogo],
  ['pnb', pnbLogo],
  ['reliance', relianceLogo],
  ['religare', religareLogo],
  ['sbi', sbiLogo],
  ['star', starLogo],
  ['tataAIA', tataAIALogo],
  ['tataAIG', tataAIGLogo],
]);

export const CARE_TYPE_CONFIG = new Map<
  string,
  { title: string; icon: string }
>([
  ['IPD', { title: 'Hospitalisation', icon: hospitalisationIcon }],
  ['DayCare', { title: 'Day care', icon: dayCareIcon }],
  ['OPD', { title: 'Out Patient Department', icon: doctorConsulatationsIcon }],
  ['HomeCare', { title: 'Home Care', icon: homeTreatmentIcon }],
  [
    'PrePost',
    { title: 'Pre and post hospitalization', icon: prePostHospitalisationIcon },
  ],
]);

export const PLUM_EMERGENCY_HELPLINE_NUMBER = '1800-30-911-911';

/**
 * It is used to Open a website in mobile's default browser - Outside app
 */
export const APP_DEEPLINK_OUTSIDE_BASE_URL = 'employee://plumhq/weboutside?id=';
/**
 * To open any native screen
 */
export const APP_DEEPLINK_BASE_URL = 'employee://plumhq';

export const isAnalyticsTurnedOn =
  IS_PROD_ENV || AppConfig.FORCE_ANALYTICS_TURN_ON;

export const TRACKER_EVENTS = {
  // Network Hospitals
  NH_SHARE_CTA_CLICKED: 'NH_SHARE_CTA_CLICKED',
  NH_CALL_CTA_CLICKED: 'NH_CALL_CTA_CLICKED',
  NH_MAP_CTA_CLICKED: 'NH_MAP_CTA_CLICKED',
  NH_BLACKLISTED_CTA_CLICKED: 'NH_BLACKLISTED_CTA_CLICKED',
  NH_LOCATION_TOGGLE: 'NH_LOCATION_TOGGLE',
  NH_SEARCH_QUERY: 'NH_SEARCH_QUERY',
  // Cashless Claims
  CC_CLAIM_CREATION_START: 'CC_CLAIM_CREATION_START',
  CC_CLAIM_CREATION_SUCCESS: 'CC_CLAIM_CREATION_SUCCESS',
  CC_CLAIM_IMPORT_VIEWED: 'CC_CLAIM_IMPORT_VIEWED',
  CC_CLAIM_IMPORT_REDIRECT: 'CC_CLAIM_IMPORT_REDIRECT',
  CC_CLAIM_CREATION_BLACKLIST_VIEWED: 'CC_CLAIM_CREATION_BLACKLIST_VIEWED',
  CC_BOT_QUESTION_ASKED: 'CC_BOT_QUESTION_ASKED',
  CC_ARTICLE_VIEWED: 'CC_ARTICLE_VIEWED',
  CC_ARTICLE_CLOSED: 'CC_ARTICLE_CLOSED',
  VIEWED_CLAIM_STATUS_PAGE: 'VIEWED_CLAIM_STATUS_PAGE',
  CC_CALLBACK_REQUEST_CLICKED: 'CC_CALLBACK_REQUEST_CLICKED',
  CC_CALLBACK_REQUEST_SUCCESS: 'CC_CALLBACK_REQUEST_SUCCESS',
  CC_CALLBACK_REQUEST_FAILURE: 'CC_CALLBACK_REQUEST_FAILURE',
  CC_CALL_PLUM_HELPLINE: 'CC_CALL_PLUM_HELPLINE',
  CC_DOWNLOAD_HEALTH_CARD: 'CC_DOWNLOAD_HEALTH_CARD',
  // Floating Widget
  FW_OPENED: 'FW_OPENED',
  FW_CLOSED: 'FW_CLOSED',
  // Claims Upload
  CU_BACK_CLICKED: 'CU_BACK_CLICKED',
  CU_CONTINUE_CLICKED: 'CU_CONTINUE_CLICKED',
  CU_CONTINUE_PROCESSED: 'CU_CONTINUE_PROCESSED',
  CU_CONTINUE_FAILED: 'CU_CONTINUE_FAILED',
  // Mid Term Addition
  MID_TERM_ADDITION_REQUEST_STARTED: 'midtermAddition::additionrequest_started',
  MID_TERM_ADDITION_REQUEST_COMPLETED:
    'midtermAddition::additionrequest_completed',
  MID_TERM_ADDITION_PAGE_LOADED: 'midtermAddition::page_loaded',
  TELHEALTH_JOIN_CALL_CLICKED: 'telehealth_joinCall_clicked',
  TELEHEALTH_PATIENT_JOINED: 'telehealth_patient_joined',
  TELHEALTH_DOCTOR_JOINED: 'telehealth_doctor_joined',
  TELHEALTH_FEEDBACK_SUBMITTED: 'telehealth_feedback_submitted',
  // Cult Fit
  CULT_FIT_OFFER_VIEWED: 'cultfit::offer_explored',
  CULT_FIT_PROCEED_CLICKED: 'cultfit::offer_proceed',
  CULT_FIT_PURCHASE_INITIATED: 'cultfit::offer_purchaseInitiated',
  CULT_FIT_PURCHASE_SUCCESS: 'cultfit::offer_purchaseCompleted',
};

export const FEATURE_FLAGS = {
  CASHLESS_BOT: 'CASHLESS_BOT',
  CASHLESS_CLAIMS_ARTICLES: 'CASHLESS_CLAIMS_ARTICLES',
  NEW_CASHLESS_CREATE: 'NEW_CASHLESS_CREATE',
  NETWORK_HOSPITALS_V3: 'NETWORK_HOSPITALS_V3',
  HEALTH_WALLET_CLAIMS_V2: 'HEALTH_WALLET_CLAIMS_V2',
  TELEHEALTH_WEB: 'TELEHEALTH_WEB',
};

export enum EDevFlag {
  IMPORT_CLAIMS = 'IMPORT_CLAIMS',
  CREATE_CLAIM = 'CREATE_CLAIM',
  SHOW_LOGS = 'SHOW_LOGS',
}

export const MOBILE_DEEPLINKS = {
  /**
   * To open the claim creation page for reimbursement claim
   */
  CREATE_REIMBURSEMENT_CLAIM: 'employee://plumhq/claims?screen=reimbursement',
  /**
   * To open the claim status page for reimbursement claim
   */
  REIMBURSEMENT_CLAIM_STATUS: 'employee://plumhq/claims?screen=details&id=',
  /**
   * To open the benefits selection page after which the network hospitals finder page will be opened
   */
  NETWORK_HOSPITALS: 'employee://plumhq/home?screen=findcashless',
  /**
   * To open cost of ailments webview page
   */
  COST_OF_AILMENTS: 'employee://plumhq/home?screen=expensecalculator',
  /**
   * To open the support center webview page
   */
  SUPPORT_CENTER: 'employee://plumhq/home?screen=inapphelpcenter',
  /**
   * To open a particular health benefit detail page
   */
  BENEFIT_DETAIL_SCREEN: 'employee://plumhq/benefits?screen=healthbenefits&id=',
};

export const ALLOWED_PARENT_ORIGINS = IS_DEVELOPMENT_ENV
  ? ['http://localhost:3000', 'https://vercel.live']
  : [
    'https://app.plumhq.com',
    'https://staging.plumhq.com',
    'https://staging-claims.plumhq.com',
    'https://plum-git-mayank-policygpt-bugfix.preview.plumhq.com',
  ];

export const ALLOWED_CHILD_ORIGINS = IS_DEVELOPMENT_ENV
  ? ['http://localhost:5174', 'http://localhost:5173', 'https://vercel.live']
  : [
    'https://chat-staging.plumhq.com',
    'https://chat.plumhq.com',
    'https://support-center.plumhq.com',
    'https://staging-support-center.plumhq.com',
  ];

export const avatarLogoMap: Partial<
  Record<`${EAddMemberRelationship}_${TGender}`, string>
> = {
  Son_MALE: KidAvatar,
  Daughter_FEMALE: KidAvatar,
  Husband_MALE: HusbandAvatar,
  Wife_FEMALE: WifeAvatar,
  SPOUSE_MALE: HusbandAvatar,
  SPOUSE_FEMALE: WifeAvatar,
  KID_MALE: KidAvatar,
  KID_FEMALE: KidAvatar,
  CHILD_MALE: KidAvatar,
  CHILD_FEMALE: KidAvatar,
  // You can add more relationships and corresponding images here
};

export const relationShipMap: Partial<
  Record<`${EAddMemberRelationship}_${TGender}`, string>
> = {
  Wife_FEMALE: 'SPOUSE',
  Husband_MALE: 'SPOUSE',
  Son_MALE: 'KID',
  Daughter_FEMALE: 'KID',
};

export const REGEXES = {
  VPA: /^[a-zA-Z0-9.-]{2,256}@[a-zA-Z]{2,64}$/,
  IFSC: /^[a-zA-Z]{4}0[a-zA-Z0-9]{6}$/,
};

export const PLUM__EMAILS = {
  CARE_ID: 'care@plumhq.com',
};

export const CULT_SKU_ID = AppConfig.CULT_SKU_ID;

export const CULT_BENEFIT_ID = AppConfig.CULT_BENEFIT_ID

export const CULT_APP_LINK = 'https://cure.app.link/7F04p3GaHyb';